import { format, parseISO } from 'date-fns'
import { IoEyeOutline } from 'react-icons/io5'

import { Badge, ButtonApp } from '@/components'
import { getBadgeVariantByStatus } from '@/utils'
import { Workflow } from '@/models/sellTreez'

type ColumnProps = { data: Workflow }

export const columnsWorkflows = (onSelect: (_: Workflow) => void) => {
  return [
    { field: 'id', headerName: 'ID', width: 200, minWidth: 200 },
    {
      field: 'created',
      headerName: 'Created at',
      cellRenderer: (props: ColumnProps) => (
        <div className="flex flex-col gap-1">
          <span className="text-gray-800 text-sm">
            {format(parseISO(props.data?.created ?? new Date().toISOString()), 'MM/dd/yyyy')}
          </span>
          <span className="text-gray-400 text-xs">
            {format(parseISO(props.data?.created ?? new Date().toISOString()), 'hh:mm:ss')}
          </span>
        </div>
      ),
    },
    {
      field: 'completedAt',
      headerName: 'Completed at',
      cellRenderer: (props: ColumnProps) => (
        <div className="flex flex-col gap-1">
          <span className="text-gray-800 text-sm">
            {format(parseISO(props.data?.completedAt ?? new Date().toISOString()), 'MM/dd/yyyy')}
          </span>
          <span className="text-gray-400 text-xs">
            {format(parseISO(props.data?.completedAt ?? new Date().toISOString()), 'hh:mm:ss')}
          </span>
        </div>
      ),
    },
    {
      field: 'workflowStatus',
      headerName: 'Status',
      pinned: 'right',
      width: 200,
      minWidth: 200,
      cellRenderer: (props: ColumnProps) => {
        const badgeVariant = getBadgeVariantByStatus(props.data.workflowStatus)

        return (
          <div className="flex items-center h-full gap-2">
            <Badge className="w-fit text-sm" {...badgeVariant} title="Status">
              {props.data.workflowStatus ?? 'unspecified'}
            </Badge>
          </div>
        )
      },
    },
    {
      headerName: 'Compare changes',
      width: 200,
      minWidth: 200,
      pinned: 'right',
      cellRenderer: ({ data: record }: ColumnProps) => (
        <div className="h-full flex items-center">
          <ButtonApp
            className="px-4 py-1.5 gap-2 h-8"
            handleClick={(e) => {
              e.stopPropagation()
              onSelect(record)
            }}
          >
            <IoEyeOutline className="text-xl text-gray-400" />
            <span className="text-sm">Preview</span>
          </ButtonApp>
        </div>
      ),
    },
  ]
}
